import { Resource } from "../resource/resource.model";

export class PreferenceWhitelist  extends Resource {
    value: string;
    description: string;
    type: string;
    status: string;
    tenantId: string;
    createdAt: Date;
    updatedAt: Date;
}